import React, { Suspense } from "react";
import { Container, Grid } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { MasterContext } from "../../context/master";
import AddAccount from "./addAccount";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
  },
  cardRoot: {
    padding: "20px 10px 20px 20px !important",
  },
}));
export default function Dashboard(props) {
  const context = useContext(MasterContext);
  const [accounts, setAccounts] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    context.GetAccounts().then((response) => setAccounts(response));
  }, [context]);

  const AccountItem = React.lazy(() => import("./accountItem"));

  return (
    <Container className={classes.root} maxWidth={false}>
      <Grid container wrap="wrap" justify="center" spacing={5}>
        {accounts?.map((account) => (
          <Grid
            item
            key={account.Account.Account_ID}
            md={6}
            xs={12}
            sm={12}
            className={classes.cardRoot}
          >
            <Suspense
              fallback={
                <>
                  <Skeleton variant="text" />
                  <Skeleton variant="circle" width={40} height={40} />
                  <Skeleton variant="rect" width={280} height={150} />
                </>
              }
            >
              <AccountItem
                siteCount={account.Sites.length}
                account={account.Account}
                siteHostName={account.Sites}
                DiskUsage={Object.values(account.Sites).map(
                  (element, index) => {
                    return element.DiskUsage;
                  }
                )}
                DiskQuata={account.Account.QuotaDiskUsage}
              />
            </Suspense>
          </Grid>
        ))}
        <AddAccount></AddAccount>
      </Grid>
    </Container>
  );
}
